import React, { useEffect, useState } from "react";
import { Box, Paper, Typography, Grid, Button } from "@mui/material";
import { useTranslation } from "react-i18next";
import i18next from "i18next";
import { useCreateSlider } from "../../hooks/sliders/useCreateSlider";
import { useUpdateSlider } from "../../hooks/sliders/useUpdateSlider";
import FormInput from "../inputs/FormInput";
import TextEditor from "../inputs/TextEditor";
import LanguageToggle from "../global/LanguageToggle";
// import { slugify } from "../../utils/slugify";

const FormAddEditSlider = ({ currentData, isEdit = false, onSubmitSuccess }) => {
    const { i18n } = useTranslation();
    const lng = i18n.language || "en";
    const isArabic = lng.startsWith("ar");
    const initialLang = localStorage.getItem("i18nextLng") || i18next.language || "ar";
    const [activeLang, setActiveLang] = useState(initialLang.startsWith("ar") ? "ar" : "en");

    // Form States المتوافقة مع الهيكل الجديد
    const [titleAr, setTitleAr] = useState("");
    const [titleEn, setTitleEn] = useState("");
    const [subTitleAr, setSubTitleAr] = useState("");
    const [subTitleEn, setSubTitleEn] = useState("");
    const [descriptionAr, setDescriptionAr] = useState("");
    const [descriptionEn, setDescriptionEn] = useState("");
    const [image, setImage] = useState(null);
    const [isActive, setIsActive] = useState(1);
    console.log("🚀 ~ FormAddEditSlider ~ isActive:", isActive)

    // const [slug, setSlug] = useState("");
    const [sortOrder, setSortOrder] = useState(0);

    // Hooks
    const { createSliderMutate, isPending: isCreating } = useCreateSlider();
    const { updateSliderMutate, isPending: isUpdating } = useUpdateSlider();

    const loadingSubmit = isCreating || isUpdating;
    // Auto-slug generation from English name
    // useEffect(() => {
    //     if (activeLang === "en" && titleEn) {
    //         if (!isEdit) {
    //             // في حالة الإضافة: قم بتوليد الرابط تلقائياً دائماً
    //             setSlug(slugify(titleEn));
    //         } else {
    //             // في حالة التعديل: قم بتوليده فقط إذا تغير الاسم الإنجليزي عن الاسم الأصلي المحفوظ
    //             const originaltitleEn = currentData?.name?.en || currentData?.name || "";
    //             if (titleEn !== originaltitleEn) {
    //                 setSlug(slugify(titleEn));
    //             }
    //         }
    //     }
    // }, [titleEn, activeLang, isEdit, currentData]);

    // تعبئة البيانات في وضع التعديل بناءً على الهيكل المتداخل الجديد
    useEffect(() => {
        if (isEdit && currentData) {
            setTitleAr(currentData?.title?.ar || "");
            setTitleEn(currentData?.title?.en || "");
            setSubTitleAr(currentData?.sub_title?.ar || "");
            setSubTitleEn(currentData?.sub_title?.en || "");
            setDescriptionAr(currentData?.description?.ar || "");
            setDescriptionEn(currentData?.description?.en || "");
            setIsActive(currentData?.is_active ?? 1);

            // setSlug(currentData?.slug || "");
            setSortOrder(currentData?.sort_order || 0);
            setImage(currentData?.image || null);
        }
    }, [isEdit, currentData]);
    // const handleSlugChange = (e) => {
    //     const val = e.target.value.toLowerCase().replace(/[^a-z0-9-]/g, "");
    //     setSlug(val);
    // };
    const handleImageChange = (e) => {
        const val = e.target.value;
        setImage(val);
    };

    const getImageName = (imageVal) => {
        if (!imageVal) return "";
        if (typeof imageVal === 'string') {
            return imageVal.substr(imageVal.lastIndexOf('/') + 1);
        }
        if (imageVal?.file_name) return imageVal.file_name;
        if (imageVal?.name) return imageVal.name;
        return imageVal;
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        // 1. إنشاء الكائن (Payload) JSON
        const payload = {
            title: {
                ar: titleAr || titleEn,
                en: titleEn || titleAr
            },
            sub_title: {
                ar: subTitleAr || subTitleEn,
                en: subTitleEn || subTitleAr
            },
            description: {
                ar: descriptionAr || descriptionEn,
                en: descriptionEn || descriptionAr
            },
            // slug: slug,
            sort_order: Number(sortOrder),
            is_active: isActive ? 1 : 0,
        };
        console.log("🚀 ~ handleSubmit ~ payload:", payload)

        if (image) {
            payload.image = getImageName(image);
        }


        // 2. إرسال البيانات
        if (isEdit) {
            updateSliderMutate({ id: currentData.id, data: payload });
        } else {
            createSliderMutate(payload);
        }
    };


    return (
        <Box component="form" onSubmit={handleSubmit} sx={{ mt: 3 }}>
            <Paper sx={{ p: 3, borderRadius: 2 }}>
                <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2, flexWrap: "wrap", gap: 2 }}>
                    <Typography variant="h6">
                        {isEdit ? (isArabic ? "تعديل السلايدر" : "Edit Slider") : (isArabic ? "إضافة سلايدر جديد" : "Add New Slider")}
                    </Typography>

                    <LanguageToggle activeLang={activeLang} onChange={(lng) => setActiveLang(lng)} showLabel={true} />
                </Box>

                <Grid container spacing={3}>
                    {/* Image Upload */}
                    <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'center', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
                        <FormInput
                            type="file"
                            name="image"
                            labelImage={isArabic ? "صورة السلايدر" : "Slider Image"}
                            value={image}
                            onChange={handleImageChange}
                            width={200}
                            height={120}
                            required={!isEdit}
                        />
                    </Grid>

                    {/* Multilingual Titles */}
                    {activeLang === "ar" && (
                        <Grid item xs={12} md={6}>
                            <FormInput
                                label="العنوان الرئيسي (عربي)"
                                placeholder="أدخل العنوان الرئيسي بالعربي"
                                value={titleAr}
                                onChange={(e) => setTitleAr(e.target.value)}
                                required
                                fullWidth
                            />
                        </Grid>
                    )}

                    {activeLang === "en" && (
                        <Grid item xs={12} md={6}>
                            <FormInput
                                label="Main Title (English)"
                                placeholder="Enter main title in English"
                                value={titleEn}
                                onChange={(e) => setTitleEn(e.target.value)}
                                required
                                fullWidth
                            />
                        </Grid>
                    )}

                    {/* Multilingual Sub Titles */}
                    {activeLang === "ar" && (
                        <Grid item xs={12} md={6}>
                            <FormInput
                                label="العنوان الفرعي (عربي)"
                                placeholder="أدخل العنوان الفرعي بالعربي"
                                value={subTitleAr}
                                onChange={(e) => setSubTitleAr(e.target.value)}
                                fullWidth
                            />
                        </Grid>
                    )}

                    {activeLang === "en" && (
                        <Grid item xs={12} md={6}>
                            <FormInput
                                label="Sub Title (English)"
                                placeholder="Enter sub title in English"
                                value={subTitleEn}
                                onChange={(e) => setSubTitleEn(e.target.value)}
                                fullWidth
                            />
                        </Grid>
                    )}
                    {/* Is Active Switch */}
                    <Grid item xs={12} md={6}>
                        <FormInput
                            type="switch"
                            label={isArabic ? "الحالة (مفعّل/معطّل)" : "Status (Active/Inactive)"}
                            name="is_active"
                            checked={!!isActive}
                            onChange={(e) => setIsActive(e.target.checked ? 1 : 0)}
                        />
                    </Grid>
                    {/* Slug Field */}
                    {/* <Grid item xs={12} md={6} >
                        <FormInput
                            label={isArabic ? "الرابط (Slug - إنجليزي فقط)" : "Slug (English only)"}
                            placeholder="Slug"
                            type="text"
                            value={slug}
                            onChange={handleSlugChange}
                            disabled={activeLang === "en"}
                            required
                            helperText={activeLang === "ar" ? (isArabic ? "يجب إدخال الرابط باللغة الإنجليزية" : "Slug must be entered in English") : ""} />
                    </Grid> */}

                    {/* Sort Order Field */}
                    <Grid item xs={12} md={6}>
                        <FormInput
                            type="number"
                            label={isArabic ? "ترتيب العرض" : "Sort Order"}
                            placeholder="0"
                            value={sortOrder}
                            onChange={(e) => setSortOrder(e.target.value)}
                            fullWidth
                        />
                    </Grid>

                    {/* Multilingual Descriptions */}
                    {activeLang === "ar" && (
                        <Grid item xs={12}>
                            <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 500 }}>
                                الوصف (عربي)
                            </Typography>
                            <TextEditor
                                name="description_ar"
                                value={descriptionAr}
                                onChange={(e) => setDescriptionAr(e.target.value)}
                                placeholder="أدخل الوصف بالعربي"
                            />
                        </Grid>
                    )}

                    {activeLang === "en" && (
                        <Grid item xs={12}>
                            <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 500 }}>
                                Description (English)
                            </Typography>
                            <TextEditor
                                name="description_en"
                                value={descriptionEn}
                                onChange={(e) => setDescriptionEn(e.target.value)}
                                placeholder="Enter description in English"
                            />
                        </Grid>
                    )}
                </Grid>

                <Box sx={{ mt: 3, display: 'flex', gap: 2 }}>
                    <Button
                        type="submit"
                        variant="contained"
                        disabled={loadingSubmit}
                        sx={{ minWidth: 120 }}
                    >
                        {loadingSubmit ? (isArabic ? "جاري الحفظ..." : "Saving...") : (isArabic ? "حفظ" : "Save")}
                    </Button>
                </Box>
            </Paper>
        </Box>
    );
};

export default FormAddEditSlider;